"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PridatPodilejiciOsobuPopup = exports.StyledDiv = exports.FlexRow = exports.ListWrap = exports.CenteredDiv = exports.PopupChildren = void 0;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/no-array-index-key */
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../../..");
var Padder_1 = require("../../../../Padder");
var Form_1 = __importDefault(require("../../../Form"));
var PodilejiciOsobaItem_1 = __importDefault(require("./PodilejiciOsobaItem"));
var PridatZpracovatelePopup_1 = require("./PridatZpracovatelePopup");
exports.PopupChildren = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: auto;\n  max-height: 70vh;\n  background-color: #f7f9fa;\n"], ["\n  overflow: auto;\n  max-height: 70vh;\n  background-color: #f7f9fa;\n"])));
exports.CenteredDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 2em;\n  display: flex;\n  justify-content: center;\n"], ["\n  margin-top: 2em;\n  display: flex;\n  justify-content: center;\n"])));
exports.ListWrap = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 10px;\n"], ["\n  margin-top: 10px;\n"])));
exports.FlexRow = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
exports.StyledDiv = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 16px;\n"], ["\n  font-size: 16px;\n"])));
var PridatPodilejiciOsobuPopup = function (_a) {
    var znalciList = _a.znalciList, addPodilejiciSe = _a.addPodilejiciSe, selectedZpracovatel = _a.selectedZpracovatel, selectedPodilejici = _a.selectedPodilejici;
    var _b = react_1.useState(selectedPodilejici || []), selectedPodilejiciOsoba = _b[0], setSelectedPodilejiciOsoba = _b[1];
    var handleChange = function (item) {
        var _a;
        var newValue = {
            clen: selectedZpracovatel.nazev,
            druh: { id: item.typExternisty === null ? __1.PosudkyTypOsoby.FyzickaOsobaPodnikajici : __1.PosudkyTypOsoby.FyzickaOsoba },
            role: {
                id: item.typExternisty === null ? __1.PosudkyRoleOsoby.ZnalecPodilejiciNaZpracovani : PridatZpracovatelePopup_1.getTypExternisty((_a = item.typExternisty) === null || _a === void 0 ? void 0 : _a.id),
            },
            jmeno: item.jmeno,
            prijmeni: item.prijmeni,
            adresaPobytu: item.adresaPobytu,
            adresaSidla: item.adresaSidla,
            nazev: item.nazev,
            ico: item.ico,
            datumNarozeni: item.datumNarozeni,
            idSubjekt: item.idSubjektu,
            idExterniOsoba: item.idExternisty,
            podiliSeJakoClen: selectedZpracovatel.idSubjekt,
            titulPred: item.titulPred,
            titulZa: item.titulZa,
            id: item.idOsoba,
        };
        var aktualni = selectedPodilejiciOsoba.find(function (po) { return po.idSubjekt === item.idSubjektu && po.idExterniOsoba === item.idExternisty; });
        if (aktualni)
            setSelectedPodilejiciOsoba(selectedPodilejiciOsoba.filter(function (po) { return po !== aktualni; }));
        else
            setSelectedPodilejiciOsoba(__spreadArrays(selectedPodilejiciOsoba, [newValue]));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.PopupChildren, null,
            react_1.default.createElement(Form_1.default, { initialValues: {}, onSubmit: function () { return addPodilejiciSe(selectedPodilejiciOsoba); } }, function (_a) {
                var isSubmitting = _a.isSubmitting;
                return (react_1.default.createElement(Padder_1.Padder, null,
                    react_1.default.createElement(exports.StyledDiv, null,
                        react_1.default.createElement("b", null, "Vyberte osobu pod\u00EDlej\u00EDc\u00ED se na zpracov\u00E1n\u00ED posudku")),
                    react_1.default.createElement(exports.StyledDiv, null, "Zvolte alespo\u0148 jednu osobu pod\u00EDlej\u00EDc\u00ED se na zpracov\u00E1n\u00ED posudku."),
                    react_1.default.createElement(exports.ListWrap, null, !!(znalciList === null || znalciList === void 0 ? void 0 : znalciList.length) &&
                        znalciList.map(function (item, i) { return (react_1.default.createElement(exports.FlexRow, { key: i },
                            react_1.default.createElement(PodilejiciOsobaItem_1.default, { znalecItem: __assign(__assign({}, item), { podiliSeJakoClen: selectedZpracovatel.idSubjekt }), setSelectedPodilejiciOsoba: handleChange, defaultChecked: selectedPodilejici === null || selectedPodilejici === void 0 ? void 0 : selectedPodilejici.find(function (s) { return (s.idSubjekt !== null ? s.idSubjekt === item.idSubjektu : s.idExterniOsoba === item.idExternisty); }) }))); })),
                    react_1.default.createElement(exports.CenteredDiv, null,
                        react_1.default.createElement(__1.Button, { type: "submit", primary: true, loading: isSubmitting, name: "pridatPodilejiciOsoby", disabled: selectedPodilejiciOsoba.length === 0 }, selectedPodilejici ? 'UPRAVIT OSOBY' : 'PŘIDAT OSOBY'))));
            }))));
};
exports.PridatPodilejiciOsobuPopup = PridatPodilejiciOsobuPopup;
exports.PridatPodilejiciOsobuPopup.defaultProps = {
    selectedPodilejici: undefined,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
